// Generated by pnpm --filter @langfuse/icons generate. Do not edit.
import { createIcon } from "../../create-icon.js";
import { FileCode2 as RawFileCode2 } from "lucide-react";
export const FileCode2 = /* @__PURE__ */ createIcon(RawFileCode2, "FileCode2", 2);
